import cx from 'classnames'
import { InputHTMLAttributes } from 'react'
import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import styles from '../form/form.module.css'

interface FormInputProps<T extends FieldValues = FieldValues>
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'name'> {
  name: Path<T>
  control: Control<T>
  label?: string
  description?: string
  wrapperClassName?: string
  labelClassName?: string
  inputClassName?: string
  testId?: string
}

export function FormInput<T extends FieldValues = FieldValues>({
  name,
  control,
  label,
  description,
  wrapperClassName,
  labelClassName,
  inputClassName,
  testId,
  ...inputProps
}: FormInputProps<T>) {
  const { t } = useTranslation()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <div className={cx('mb-4', wrapperClassName)}>
          {label && (
            <label
              className={cx('text-md text-grey-10000', labelClassName)}
              htmlFor={name}
            >
              {label}
            </label>
          )}
          {description && (
            <label
              className={cx('text-zinc-500 text-sm font-normal')}
              htmlFor={name}
            >
              {description}
            </label>
          )}
          <input
            id={name}
            {...field}
            className={cx(styles.customInput, inputClassName)}
            data-testid={testId}
            {...inputProps}
          />
          {fieldState.error && (
            <span
              className={styles.errorMessage}
              data-testid={`${testId}-error`}
            >
              {t(`validation_messages.${fieldState.error.message}`)}
            </span>
          )}
        </div>
      )}
    />
  )
}
